<template>
  <div class="keyboard-game">
    <!-- v-if="isRunning" -->
    <div class="game-keyboard" v-show="isRunning && isShowKeyboard">
      <!-- 字母提示 -->
      <div class="top top-keyboard">
        <PracticeHint
          ref="KeyStyle"
          :input-str="inputStr"
          @finish="handleFinish"
          :can-operate="canOperate"
          @inputRight="inputRight"
          @pause="handlePause"
        />
      </div>
      <!-- 虚拟键盘 -->
      <div class="bottom bottom-keyboard">
        <SimpleKeyboard
          ref="Keyboard"
          @onChange="onChange"
          @onKeyPress="onKeyPress"
          :input="input"
          :next-input="nextKey"
          :show-gesture="true"
          right-color="#00B0FF"
        />
      </div>
    </div>
    <!-- 继续游戏、 冲洗开始、退出-->
    <div class="game-keyboard-control" v-if="status === 'pause'">
      <div
        class="game-keyboard-control-item continue"
        @click="handlePause(false)"
      ></div>
      <div
        class="game-keyboard-control-item restart"
        @click="handleRestart"
      ></div>
      <div class="game-keyboard-control-item exit" @click="handleExit"></div>
    </div>
    <!-- 游戏结算 v-if="showResultModal" -->
    <GameResultModal
      v-if="showResultModal"
      :game-result="status"
      :finish-params="finishParams"
      @restart="handleRestart"
      @nextLevel="nextLevel"
      @finishCurrentLevel="finishCurrentLevel"
      :show-next-level="!!nextLevelInfo"
    />
  </div>
</template>

<script>
import SimpleKeyboard from "@/SimpleKeyboardV2";
import PracticeHint from "./PracticeHint.vue";
import { gestureObjV2 } from "@/gestureRow.js";
import { EventBus } from "../index.vue";
import { mapState, mapGetters, mapActions } from "vuex";
import GameResultModal from "./GameResultModal.vue";
import { isXpad, isStudentEnd } from "@/utils";
import { getKeyboardDetail, finishKeyboard } from "@http/index";
import WXJsBridge from "@xes/wxjsbridge/src";

export default {
  components: {
    SimpleKeyboard,
    PracticeHint,
    GameResultModal,
  },
  data() {
    return {
      input: "",
      inputStr: [],
      canOperate: true,
      finishParams: {
        //渠道 0=学习机 1=编程社区
        channel: 0,
        time: 0, // 时间(单位:秒)|指法必填|视频必填
        correctness: 0, // 正确率(分子,max=100)|指法必填
        velocity: 0, // 速度(键)|指法必填
        startTime: 0,
        endTime: 0,
      },
      nextLevelInfo: null, //下一节信息 用于展示是否存在下一节
      isShowKeyboard: true,
      nextKey: "",
    };
  },
  computed: {
    ...mapState("keyboardGame", ["status"]),
    ...mapGetters("keyboardGame", ["isRunning"]),
    showResultModal() {
      return this.status === "fail" || this.status === "win";
    },
    isPausedOrFinish() {
      return (
        this.status === "pause" ||
        this.status === "win" ||
        this.status === "fail"
      );
    },
  },
  watch: {
    // 游戏开始，键盘事件启动
    isRunning(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.setKeyboardCompare();
        });
      }
    },
    // 添加对 showResultModal 的监听
    showResultModal(newVal) {
      this.showPageLog("jiuge_exercise_complete_pop_show");
      if (newVal && this.status === "fail") {
        this.getFailFinishParams();
      }
    },
    status(newVal) {
      if (newVal === "start") {
        this.finishParams.startTime = new Date().getTime();
      }
    },
  },
  created() {
    this.init();
    this.fetchLevelMessage()
  },
  beforeDestroy() {
    this.timer && clearTimeout(this.timer)
    this.$store.dispatch("keyboardGame/readyGame");
    this.onSetShowKeyboard(false);
  },
  mounted() {
    window.addEventListener("keydown", this.handleKeydown);
    window.addEventListener("keyup", this.handleKeyup);

    // 移动端触摸事件
    window.addEventListener("touchstart", this.handleTouchStart);
    window.addEventListener("touchend", this.handleTouchEnd);

    // 当开始输入非直接的字符序列（例如拼音）时触发
    window.addEventListener("compositionstart", () => {
      this.language = "中文";
    });
    // 当结束输入非直接的字符序列时触发
    window.addEventListener("compositionend", () => {
      this.language = "英文";
    });
    EventBus.$on("setShowKeyboard", this.onSetShowKeyboard);
  },
  methods: {
    ...mapActions("keyboardGame", ["gameOver"]),
    showPageLog(clickname) {
      if (!this.$route.query.keyboard_id) {
        return;
      }
      const data = {
        clickname,
        keyboard_id: this.$route.query.keyboard_id,
        practical_type: 3, // 1=字符输入型 2=段落输入型 3=游戏练习
        plan_id: this.$route.query.planId || "",
        course_id: this.$route.query.courseId || "",
        outline_id: this.$route.query.outlineId || "",
        issuccess: this.status === "win" ? 1 : this.status === "fail" ? 0 : -1,
      };
      window.logger.sendLog("click", data);
    },
    getFailFinishParams() {
      const resultData =
        this.$refs.KeyStyle && this.$refs.KeyStyle.getResultData();
      console.log("resultData:", resultData);
      this.finishParams.correctness = resultData.correctness;
      this.finishParams.totalNum = resultData.totalNum;
      this.finishParams.endTime = new Date().getTime();
      const duration = this.finishParams.endTime - this.finishParams.startTime;
      const seconds = Math.floor(duration / 1000);
      this.finishParams.time = seconds;
      this.finishParams.velocity = Math.floor(
        (resultData.correctNum / seconds) * 60
      );
      this.finishParams.timeStr =
        seconds < 3600
          ? new Date(duration).toISOString().substr(14, 5)
          : new Date(duration).toISOString().substr(11, 8);

      console.log("getFailFinishParams:", this.finishParams);
    },
    init() {
      if (this.$route.query.node_id) {
        this.finishParams.node_id = this.$route.query.node_id;
      }
      if (isXpad()) {
        // 学习机
        this.finishParams.channel = 0;
        this.checkBlueTooth();
      } else {
        // 编程社区
        this.finishParams.channel = 1;
      }
    },
    checkBlueTooth() {
      window.XpadBridgeSdk.blueToothKeyboard((data) => {
        data = JSON.parse(data);
        const { isConnectionKeyBoard, isOpenPermission } = data;
        console.log("in gamekeyboard isConnectionKeyBoard", data);
        if (!isConnectionKeyBoard) {
          // 蓝牙键盘链接
          this.$toast("蓝牙键盘未链接", {
            type: "error",
            duration: 2000,
          });
          return;
        }
        if (!isOpenPermission) {
          // 蓝牙权限开启
          this.$toast("蓝牙权限未开启", {
            type: "error",
            duration: 2000,
          });
          return;
        }
      });
    },
    onSetShowKeyboard(data) {
      console.log("887878", data);
      this.isShowKeyboard = data;
    },
    handlePause(isPaused) {
      EventBus.$emit("setPause", isPaused);
    },
    // 需要直接开始游戏，而非进入开始页面
    async handleRestart() {
      this.showPageLog("jiuge_exercise_learn_again_click");
      this.timer && clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        // 重新加载路由，添加query参数restart=true
        this.$router.replace({
          path: this.$route.path,
          query: {
            ...this.$route.query,
            restart: true,
          },
        });
        this.$router.go(0);
      }, 200)
    },
    // 如果是学生端走关闭窗口，否则走返回列表页
    handleExit() {
      if (
        window.XesInstance.isMobileApp() ||
        window.XesInstance.isWdFunction()
      ) {
        setTimeout(() => {
          if (window.XesInstance.isAndroidFunction()) {
            // eslint-disable-next-line no-undef
            WXJsBridge.closeWebView();
          } else {
            // eslint-disable-next-line no-undef
            window.XesInstance && window.XesInstance.closeWindowFunction();
          }
        }, 500);
      } else {
        this.$router.replace({
          path: "/list",
        });
      }
    },
    async handleFinish(resultData) {
      // Todo 游戏结束
      if (this.status === "fail") {
        return;
      }
      const { correctness, totalNum } = resultData;
      this.finishParams.endTime = new Date().getTime();
      const duration = this.finishParams.endTime - this.finishParams.startTime;
      const seconds = Math.floor(duration / 1000);
      this.finishParams.time = seconds;
      // 单位，未超过1小时，mm:ss；超过1小时，hh:mm:ss
      this.finishParams.timeStr =
        seconds < 3600
          ? new Date(duration).toISOString().substr(14, 5)
          : new Date(duration).toISOString().substr(11, 8);
      this.finishParams.correctness = correctness;
      // 速度=输入正确的字符数（=所有字符数）/闯关用时（秒）/60（秒）单位：键/分钟
      this.finishParams.velocity = Math.floor(
        (resultData.correctNum / seconds) * 60
      );
      console.log("测试验证 结果：", this.finishParams);

      window.XpadBridgeSdk && window.XpadBridgeSdk.closeAutoLog();
      try {
        const params = { ...this.finishParams, keyboard_id: this.keyboardId };

        const queryParams = this.$route.query;
        const otherParams = {
          ...(queryParams.planId ? { planId: queryParams.planId } : {}),
          ...(queryParams.stuCouId ? { stuCouId: queryParams.stuCouId } : {}),
          ...(queryParams.courseId ? { courseId: queryParams.courseId } : {}),
        };
        const res = await finishKeyboard({ ...params, ...otherParams });
        this.nextLevelInfo =
          res.data && res.data.nextLevel ? res.data.nextLevel : null;

        this.onSetShowKeyboard(false);
        EventBus.$emit("gameWin");
      } catch (error) {
        const message = `下一个关卡异常，请返回首页后重新进入`;
        this.$toast(message, {
          type: "error",
          duration: 2000,
        });
        setTimeout(() => {
          this.$router.replace({
            path: `/list`,
          });
        }, 2000);
      }
    },
    finishCurrentLevel() {
      this.showPageLog("jiuge_exercise_complete_click");
    },
    inputRight() {
      EventBus.$emit("setCorrect");
    },
    onChange(input) {
      this.input = input;
    },
    onKeyPress(button) {
      window.console.log("button", button);
    },
    nextLevel() {
      this.showPageLog("jiuge_exercise_continue_click");
      if (!this.nextLevelInfo) {
        this.$toast("恭喜你已完成所有关卡", {
          type: "success",
          duration: 2000,
        });
        setTimeout(() => {
          this.$router.replace({
            path: `/list`,
          });
        }, 2000);
        return;
      }
      const NODE_TYPE_ROUTE_MAP = {
        1: "video",
        2: "finger",
      };
      const route_name = NODE_TYPE_ROUTE_MAP[this.nextLevelInfo.node_type];
      let newUrl = `//${window.location.host}/tools/keyboard/${route_name}/${this.nextLevelInfo.id}`;
      if (this.nextLevelInfo.category === 2) {
        newUrl = `//${window.location.host}/tools/keyboard/game?keyboard_id=${this.nextLevelInfo.keyboard_id}&node_id=${this.nextLevelInfo.id}`;
      }
      window.location.replace(newUrl);
    },
    async fetchLevelMessage() {
      let params = {};
      // 如果是通过键盘id获取
      if (this.$route.query.keyboard_id) {
        params = {
          ...params,
          keyboard_id: this.$route.query.keyboard_id,
        };
      }
      if (this.$route.query.node_id) {
        params = {
          ...params,
          node_id: this.$route.query.node_id,
        };
      }
      try {
        const res = await getKeyboardDetail(params);
        console.log("keyboardGame res:", res);
        const { keyboard_content, operation_mode, keyboard_id, category } =
          res.data;
        this.keyboardId = keyboard_id;
        this.nodeInfo = res.data;
        // category 1 常规练习 2 是游戏
        // 将inputStr中的\n替换成 ↵
        let keyboardContent = Array.isArray(keyboard_content)
          ? keyboard_content
          : JSON.parse(keyboard_content);

        this.inputStr = keyboardContent.map((item) => {
          return item.replace(/\n/g, "↵");
        });
        console.error("inputStr:", this.inputStr);
        this.nextKey = this.inputStr[0][0];
        this.highlight();
      } catch (error) {
        console.error("获取键盘详情失败", error);
        this.$toast('获取键盘详情失败哦', {
          type: "error",
          duration: 2000,
        });
        setTimeout(() => {
          this.$router.replace({
            path: `/list`,
          });
        }, 2000);
      }
    },
    highlight() {
      if (this.nextKey === undefined) {
        return;
      }
      let keys = [this.nextKey.toLowerCase()];
      if (gestureObjV2[this.nextKey] && gestureObjV2[this.nextKey].keys) {
        keys = gestureObjV2[this.nextKey].keys;
        keys.push(this.nextKey.toLowerCase());
      }
      this.$refs.Keyboard && this.$refs.Keyboard.highlight(keys);
    },
    clearHighlight() {
      this.$refs.Keyboard && this.$refs.Keyboard.clearHighlight();
    },
    handleKeydown(event) {
      const blackList = [
        " ",
        "Tab",
        "Escape",
        "Enter",
        "ArrowUp",
        "ArrowDown",
        "ArrowLeft",
        "ArrowRight",
      ];
      if (blackList.includes(event.key)) {
        event.preventDefault();
      }
      if (
        (event.ctrlKey || event.metaKey) &&
        (event.key === "a" || event.key === "A")
      ) {
        event.preventDefault();
      }
      if (event.key === "Shift") {
        this.isShifting = true;
      }
      this.clearHighlight();
      this.highlight();
    },
    handleKeyup(event) {
      if (event.key === "Shift") {
        this.isShifting = false;
      }
      this.clearHighlight();
      this.highlight();
    },
    handleTouchStart(event) {
      const target = event.target;
      const key = target.getAttribute("data-skbtn");
      if (key) {
        if (key === "{shiftleft}" || key === "{shiftright}") {
          this.isShifting = true;
        }
      }
    },

    handleTouchEnd(event) {
      const target = event.target;
      const key = target.getAttribute("data-skbtn");
      if (key) {
        if (key === "{shiftleft}" || key === "{shiftright}") {
          this.isShifting = false;
        }
      }
      this.clearHighlight();
      this.highlight();
    },
    transferBtn(originBtn) {
      let targetBtn = originBtn;
      if (originBtn >= "A" && originBtn <= "Z") {
        if (!this.isShifting) {
          targetBtn = originBtn.toLowerCase();
        }
      }
      return targetBtn;
    },
    setKeyboardCompare() {
      if (!this.$refs.Keyboard) return;
      this.$refs.Keyboard.compare = (btn) => {
        console.log("isPausedOrFinish", this.isPausedOrFinish);
        if (this.isPausedOrFinish) return false;
        btn = this.transferBtn(btn);
        var ch = "";
        const keyStyleComp = this.$refs.KeyStyle;
        ch = keyStyleComp.nextWord();
        keyStyleComp.removeKey(btn);
        this.nextKey = keyStyleComp.nextKey();
        this.highlight();

        let isRight = ch === btn;
        if (ch === "↵" && btn === "{enter}") {
          isRight = true;
        } else if (!gestureObjV2[ch] || !gestureObjV2[ch].keys) {
          console.log("lx ch", ch);
        } else {
          // 组合键
          gestureObjV2[ch].keys.push(ch.toLowerCase());
          isRight = isRight || gestureObjV2[ch].keys.includes(btn + "");
        }
        return isRight;
      };
    },
  },
};
</script>

<style scoped lang="less">
.keyboard-game {
  width: 100%;
  height: 100%;
}
.game-keyboard {
  width: 100%;
  // height: 100vh;
  height: 100%;
}

.top,
.bottom {
  height: 50%; /* 各占50% */
  width: 100%;
  box-sizing: border-box;
}

.top-keyboard {
  display: flex;
  justify-content: center;
  font-size: 60px;
  color: #fff;
  font-weight: 600;
  align-items: flex-start;
}

.bottom-keyboard {
  width: 100%;
  height: 100%;
  margin-top: 60px;
  display: flex;
  justify-content: center;
  scale: 1.1;
}

.game-keyboard-control {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);

  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .game-keyboard-control-item {
    width: 362px;
    height: 80px;
    border-radius: 10px;
    margin-bottom: 10px;
    text-align: center;
    line-height: 50px;
    font-size: 20px;
    font-weight: 600;
    color: #000;
    cursor: pointer;

    &.continue {
      background-image: url("../../../assets/game/images/btn-control-continue.png");
      background-size: 100% 100%;
    }
    &.restart {
      background-image: url("../../../assets/game/images/btn-control-restart.png");
      background-size: 100% 100%;
    }
    &.exit {
      background-image: url("../../../assets/game/images/btn-control-exit.png");
      background-size: 100% 100%;
    }
  }
}
</style>
